<template>
<div>
  <main>
    <div>
      <error-data v-if="isErrorDataSet"/>
      <div v-else>
        <order-details-top :transaction="transaction"
                           :visibility="visibilityOptions"
                           :show-button="false" />
        <div class="container">
          <h1 class="page-title_hidden" id="page-title-for-sr">{{ $t('paywayError.pageTitle') }}</h1>
          <div class="columns confirmation">
            <section class="sidebar-column" id="payment-section-summary" aria-labelledby="section-summary-heading">
              <order-details-side :transaction="transaction"
                                  :visibility="visibilityOptions"
                                  :show-button="false" />
            </section>
            <section class="main-column">
              <div class="content confirmation-wrapper">
                <div class="payway-error">
                  <h2 class="normal" v-html="$t('paywayError.header')"></h2>
                  <p v-html="$t('paywayError.description')"></p>
                </div>
                <payway-error-button v-if="visibilityOptions && visibilityOptions.showReturnToShopButton" />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
    </div>
</template>

<script>
import { pageTitle } from '@/base/const/routing.const'
import { MatomoClass } from '@/base/class/matomo.class'
import { MATOMO_EVENT_CATEGORY, MATOMO_EVENT_TYPE, MATOMO_VIEW_ACTION } from '@/base/const/matomo.const'
import { mapGetters, mapMutations, mapState } from 'vuex'
import OrderDetailsSide from '@/base/components/OrderDetails/Side.vue'
import OrderDetailsTop from '@/base/components/OrderDetails/Top'
import PaywayErrorButton from '@/base/components/Payment/Paywall/PaywayError/PaywayErorrButton'
import { ERROR_CODES_NAMES } from '@/base/const/errorCodes.const'
import ErrorData from '@/base/components/Error/Data'

export default {
  name: 'PaywayError',
  metaInfo () {
    return {
      title: pageTitle().base,
      titleTemplate: '%s | ' + pageTitle().paywayError
    }
  },
  components: {
    OrderDetailsSide,
    OrderDetailsTop,
    ErrorData,
    PaywayErrorButton
  },
  computed: {
    ...mapState({
      transaction: state => state.payment.paymentData?.transaction?.orderId ? state.payment.paymentData.transaction : null,
      visibilityOptions: state => state.payment.paymentData ? state.payment.paymentData.visibilityOptions : null
    }),
    ...mapGetters({
      isErrorDataSet: 'isErrorDataSet'
    })
  },
  methods: {
    ...mapMutations([
      'SET_ERROR_DATA',
      'SET_PAYMENT_PAYWALL_VIEW'
    ])
  },
  mounted () {
    MatomoClass.sendEvent([MATOMO_EVENT_TYPE.trackEvent, MATOMO_EVENT_CATEGORY.view, MATOMO_VIEW_ACTION.paywayError])
    if (!this.transaction) {
      this.SET_PAYMENT_PAYWALL_VIEW(false)
      this.SET_ERROR_DATA({
        errorCode: ERROR_CODES_NAMES.GENERAL_ERROR,
        errorUrl: null
      })
    }
  }
}

</script>
